import * as generic from './generic-actions';
import * as searchHotel from './search-hotel-actions';

export const Actions = {
    ...generic.All,
    ...searchHotel.All
};
